import { Component } from "@angular/core";

@Component({
    selector: "wk-icon-client-code-sprite-pds3",
    templateUrl: "./wk-icon-client-code-sprite-pds3.html",
    host: { class: "cg3-host-wk-icon-client-code-sprite" },
})
export class WkIconClientCodeSpritePds3 {}
